import { editor } from '@wix/editor';
import { createClient } from '@wix/sdk';

export const enableClient = () => {
  const host = editor.host();
  const auth = editor.auth();

  const wixClient = createClient({
    auth,
    host,
  });
  wixClient.enableContext('module');
};
